import logoImage from 'assets/images/logo-color.png';
import React from 'react';

export default function Logo() {
  return <img src={logoImage} alt="TXT logo" />;
}
